export const initialState = {
  basket: [],
  user: null
};

// Selector
export const getBasketTotal = (basket) =>
  basket?.reduce((amount, item) => item.price + amount, 0); //tallies up the basket and sums up all the price and returns it. 

const reducer = (state, action) => {
  console.log(action);
  switch (action.type) {
    case "ADD_TO_BASKET":
      return {
        ...state, //previous state of basket
        basket: [...state.basket, action.item], //previous state of basket + whatever we've decided add
      };
    
    case "EMPTY_BASKET":
      return {
        ...state,
        basket: []
      }
    
    case "REMOVE_FROM_BASKET":
      const index = state.basket.findIndex(
        (basketItem) => basketItem.id === action.id
      );
      let newBasket = [...state.basket];

      if (index >= 0) {
        newBasket.splice(index, 1);

      } else {
        console.warn(
          `Can't remove product (id: ${action.id}) as it's not in basket!`
        )
      }

      return {
        ...state,
        basket: newBasket
      }
    
      case "SET_USER":
        return {
          ...state,
          user: action.user
        }
      
    default:
      return state;
  }

 
};

export default reducer;
  